module.exports = __webpack_public_path__ + "02_very_short_black.aa52d1b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_very_short_black.png
// module id = 8vil
// module chunks = 0